export default __webpack_public_path__ + "static/char-v-09-19cfe9c8ad404f0b6e20894ed2bd7d79.mp4";